import { Injectable } from '@angular/core';
import { Rutas } from '../../utiles/Rutas';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PageService {
  public estadisticas: any;
  public expedientes: any;
  public estadistica: any;

  constructor(private http: HttpClient) {}

  add_expediente(datos): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(Rutas + 'add_expediente', datos, { headers });
  }

  public async setExpedientes(expedientes): Promise<any> {
    this.expedientes = expedientes;
  }

  public async setEstadisticas(estadisticas, estadistica): Promise<any> {
    this.estadisticas = estadisticas;
    this.estadistica = estadistica;
  }

  getProvincia(): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(Rutas + 'get_provincias', { headers });
  }
  getUploadSize(): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(Rutas + 'uploadsize', { headers });
  }
  getUploadSizePublic(): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(Rutas + 'public/uploadsize', { headers });
  }

  getRangos(): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(Rutas + 'get_all_rangos', { headers });
  }

  getFechaRangos(): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(Rutas + 'get_rango_fechas', { headers });
  }

  getMuninicipio(provincia): any {
    //fsdfsd
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const json = JSON.stringify({ cp: provincia });
    return this.http.post(Rutas + 'get_municipios_provincias', json, {
      headers,
    });
  }

  updateDefaultRango(id): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const json = JSON.stringify({ id });
    return this.http.post(Rutas + 'update_default_rango', json, { headers });
  }

  getSiglas(): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(Rutas + 'siglas_calles', { headers });
  }

  getColaborador(apellido: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'colaborador',
      JSON.stringify({ colaborador: apellido }),
      { headers }
    );
  }

  getCliente(nif: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_cliente',
      JSON.stringify({ NIF_Cliente: nif }),
      { headers }
    );
  }

  getModeloIdae(cadenaBusqueda: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_modelo_idae',
      JSON.stringify({ modelo: cadenaBusqueda }),
      { headers }
    );
  }

  getApoderado(nif: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_apoderado',
      JSON.stringify({ NIF_Apoderado: nif }),
      { headers }
    );
  }

  getOneSolicitud(solicitud: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_solicitud_id',
      JSON.stringify({ id: solicitud }),
      { headers }
    );
  }

  getOneVehiculo(dato: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_vehiculo',
      JSON.stringify({ matricula: dato }),
      { headers }
    );
  }

  add_file(datos): any {
    console.log(datos);
    return this.http.post(Rutas + 'post_solicitud', datos, {
      reportProgress: true,
      observe: 'events',
    });
  }

  update_solicitud(datos): any {
    console.log(datos);
    return this.http.post(Rutas + 'update_solicitud', datos);
  }

  getDirecciones(nif: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_direccion_cliente',
      JSON.stringify({ nifCliente: nif }),
      { headers }
    );
  }

  getDireccion($id: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_direccion_cliente_id',
      JSON.stringify({ id: $id }),
      { headers }
    );
  }

  getUsers(): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(Rutas + 'admin/users', { headers });
  }

  getColaboradoresGrupos(): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(Rutas + 'admin/colaboradores_nombres', { headers });
  }

  postUser(
    colaborador: string,
    email: string,
    rol: string,
    password: string
  ): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http.post(
      Rutas + 'admin/create_user',
      JSON.stringify({ colaborador, email, rol, password }),
      {
        headers,
        responseType: 'text' as 'json',
      }
    );
  }

  deleteUser(id: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(Rutas + 'admin/delete_user', JSON.stringify({ id }), {
      headers,
      responseType: 'text' as 'json',
    });
  }

  forcePassword(email: string, password: string): any {
    console.log(password);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'admin/reset_password',
      JSON.stringify({ email, password }),
      { headers, responseType: 'text' as 'json' }
    );
  }

  updateUser(old_email: string, new_email: string, rol: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'admin/update_user',
      JSON.stringify({ old_email, new_email, rol }),
      { headers, responseType: 'text' as 'json' }
    );
  }

  getCargos(): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(Rutas + 'getCargos', { headers });
  }

  getAcciones(): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(Rutas + 'getAcciones', { headers });
  }

  getAccionesContacto(codigo: any): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(Rutas + 'getAccionesContacto?idcontacto=' + codigo, {
      headers,
    });
  }

  addContacto(contacto: any): any {
    return this.http.post(Rutas + 'addContacto', contacto);
  }

  updateContacto(contacto: any): any {
    return this.http.post(Rutas + 'updateContacto', contacto);
  }

  deleteContacto(idContacto: any): any {
    return this.http.post(Rutas + 'deleteContacto', idContacto);
  }

  getContactosByColaborador(codigo: any): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(Rutas + 'getContactos?colaborador=' + codigo, {
      headers,
    });
  }

  sendTestEmail(email: any): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.get(Rutas + 'sendTestEmail?to=' + email, { headers });
  }

  getTipoVehiculo(tipoVehiculo): number {
    let v: number;
    switch (tipoVehiculo) {
      case '03':
      case '04':
        v = 1;
        break;
      case '66':
        v = 2;
        break;
      default:
        v = 3;
        break;
    }
    return v;
  }

  getRegion(provincia): string {
    const codigo = parseInt(provincia, 10);
    let v: string;
    switch (codigo) {
      case 4:
      case 11:
      case 14:
      case 18:
      case 21:
      case 23:
      case 29:
      case 41:
        v = 'Andalucia';
        break;
      case 33:
        v = 'Asturias';
        break;
      case 7:
        v = 'Baleares';
        break;
      case 35:
      case 38:
        v = 'Canarias';
        break;
      case 39:
        v = 'Cantabria';
        break;
      case 8:
      case 17:
      case 25:
      case 43:
        v = 'Cataluña';
        break;
      case 3:
      case 12:
      case 46:
        v = 'Comunidad Valenciana';
        break;
      case 6:
      case 10:
        v = 'Extremadura';
        break;
      case 30:
        v = 'Murcia';
        break;
      case 51:
      case 52:
        v = 'Ceuta y Melilla';
        break;
      default:
        v = 'Peninsula';
        break;
    }
    return v;
  }

  cacularImpositivo(tipoV, prov, cv, co): number {
    if (tipoV !== '' && prov !== '') {
      const tipoVehiculo = this.getTipoVehiculo(tipoV);
      const region = this.getRegion(prov);
      if (tipoVehiculo === 3) {
        if (region === 'Peninsula') {
          if (co <= 120) {
            return 0;
          }
          if (co > 120 && co < 160) {
            return 4.75;
          }
          if (co >= 160 && co < 200) {
            return 9.75;
          }
          if (co >= 200) {
            return 14.75;
          }
        }

        if (region === 'Canarias') {
          if (co <= 120) {
            return 0;
          }
          if (co > 120 && co < 160) {
            return 3.75;
          }
          if (co >= 160 && co < 200) {
            return 8.75;
          }
          if (co >= 200) {
            return 13.75;
          }
        }

        if (region === 'Ceuta y Melilla') {
          if (co <= 120) {
            return 0;
          }
          if (co > 120 && co < 160) {
            return 0;
          }
          if (co >= 160 && co < 200) {
            return 0;
          }
          if (co >= 200) {
            return 0;
          }
        }

        if (region === 'Andalucia') {
          if (co <= 120) {
            return 0;
          }
          if (co > 120 && co < 160) {
            return 4.75;
          }
          if (co >= 160 && co < 200) {
            return 9.75;
          }
          if (co >= 200) {
            return 14.75;
          }
        }

        if (region === 'Asturias') {
          if (co <= 120) {
            return 0;
          }
          if (co > 120 && co < 160) {
            return 4.75;
          }
          if (co >= 160 && co < 200) {
            return 9.75;
          }
          if (co >= 200) {
            return 16.0;
          }
        }

        if (region === 'Baleares') {
          if (co <= 120) {
            return 0;
          }
          if (co > 120 && co < 160) {
            return 4.75;
          }
          if (co >= 160 && co < 200) {
            return 9.75;
          }
          if (co >= 200) {
            return 16.0;
          }
        }

        if (region === 'Cantabria') {
          if (co <= 120) {
            return 0;
          }
          if (co > 120 && co < 160) {
            return 4.75;
          }
          if (co >= 160 && co < 200) {
            return 9.75;
          }
          if (co >= 200) {
            return 15.0;
          }
        }

        if (region === 'Cataluña') {
          if (co <= 120) {
            return 0;
          }
          if (co > 120 && co < 160) {
            return 5.2;
          }
          if (co >= 160 && co < 200) {
            return 11;
          }
          if (co >= 200) {
            return 16.0;
          }
        }

        if (region === 'Extremadura') {
          if (co <= 120) {
            return 0;
          }
          if (co > 120 && co < 160) {
            return 4.75;
          }
          if (co >= 160 && co < 200) {
            return 9.75;
          }
          if (co >= 200) {
            return 16.0;
          }
        }

        if (region === 'Murcia') {
          if (co <= 120) {
            return 0;
          }
          if (co > 120 && co < 160) {
            return 4.75;
          }
          if (co >= 160 && co < 200) {
            return 9.75;
          }
          if (co >= 200) {
            return 15.9;
          }
        }

        if (region === 'Comunidad Valenciana') {
          if (co <= 120) {
            return 0;
          }
          if (co > 120 && co < 160) {
            return 4.75;
          }
          if (co >= 160 && co < 200) {
            return 9.75;
          }
          if (co >= 200) {
            return 16.0;
          }
        }
      }

      if (tipoVehiculo === 2) {
        if (region === 'Peninsula') {
          if (co >= 200) {
            return 14.75;
          }
        }

        if (region === 'Canarias') {
          if (co >= 200) {
            return 13.75;
          }
        }

        if (region === 'Ceuta y Melilla') {
          if (co >= 200) {
            return 0;
          }
        }

        if (region === 'Andalucia') {
          if (co >= 200) {
            return 14.75;
          }
        }

        if (region === 'Asturias') {
          if (co >= 200) {
            return 16.0;
          }
        }

        if (region === 'Baleares') {
          if (co >= 200) {
            return 16.0;
          }
        }

        if (region === 'Cantabria') {
          if (co >= 200) {
            return 15.0;
          }
        }

        if (region === 'Cataluña') {
          if (co >= 200) {
            return 16.0;
          }
        }

        if (region === 'Extremadura') {
          if (co >= 200) {
            return 16.0;
          }
        }

        if (region === 'Murcia') {
          if (co >= 200) {
            return 15.9;
          }
        }

        if (region === 'Comunidad Valenciana') {
          if (co >= 200) {
            return 16.0;
          }
        }
      }

      if (tipoVehiculo === 1) {
        if (tipoV !== '' && prov !== '') {
          if (region === 'Peninsula') {
            if (co <= 100 && cv < 100) {
              return 0;
            }
            if (co > 100 && co <= 120 && cv < 100) {
              return 4.75;
            }
            if (co > 120 && co <= 139 && cv < 100) {
              return 9.75;
            }
            if (co >= 120 && cv >= 100) {
              return 14.75;
            }
          }

          if (region === 'Canarias') {
            if (co <= 100 && cv < 100) {
              return 0;
            }
            if (co > 100 && co <= 120 && cv < 100) {
              return 3.75;
            }
            if (co > 120 && co <= 139 && cv < 100) {
              return 8.75;
            }
            if (co >= 120 && cv >= 100) {
              return 13.75;
            }
          }

          if (region === 'Ceuta y Melilla') {
            if (co <= 100 && cv < 100) {
              return 0;
            }
            if (co > 100 && co <= 120 && cv < 100) {
              return 0;
            }
            if (co > 120 && co <= 139 && cv < 100) {
              return 0;
            }
            if (co >= 120 && cv >= 100) {
              return 0;
            }
          }

          if (region === 'Andalucia') {
            if (co <= 100 && cv < 100) {
              return 0;
            }
            if (co > 100 && co <= 120 && cv < 100) {
              return 4.75;
            }
            if (co > 120 && co <= 139 && cv < 100) {
              return 9.75;
            }
            if (co >= 120 && cv >= 100) {
              return 16.9;
            }
          }

          if (region === 'Asturias') {
            if (co <= 100 && cv < 100) {
              return 0;
            }
            if (co > 100 && co <= 120 && cv < 100) {
              return 4.75;
            }
            if (co > 120 && co <= 139 && cv < 100) {
              return 9.75;
            }
            if (co >= 120 && cv >= 100) {
              return 16.0;
            }
          }

          if (region === 'Baleares') {
            if (co <= 100 && cv < 100) {
              return 0;
            }
            if (co > 100 && co <= 120 && cv < 100) {
              return 4.75;
            }
            if (co > 120 && co <= 139 && cv < 100) {
              return 9.75;
            }
            if (co >= 120 && cv >= 100) {
              return 16.0;
            }
          }

          if (region === 'Cantabria') {
            if (co <= 100 && cv < 100) {
              return 0;
            }
            if (co > 100 && co <= 120 && cv < 100) {
              return 4.75;
            }
            if (co > 120 && co <= 139 && cv < 100) {
              return 9.75;
            }
            if (co >= 120 && cv >= 100) {
              return 15.0;
            }
          }

          if (region === 'Cataluña') {
            if (co <= 100 && cv < 100) {
              return 0;
            }
            if (co > 100 && co <= 120 && cv < 100) {
              return 5.2;
            }
            if (co > 120 && co <= 139 && cv < 100) {
              return 11.0;
            }
            if (co >= 120 && cv >= 100) {
              return 16.0;
            }
          }

          if (region === 'Extremadura') {
            if (co <= 100 && cv < 100) {
              return 0;
            }
            if (co > 100 && co <= 120 && cv < 100) {
              return 5.2;
            }
            if (co > 120 && co <= 139 && cv < 100) {
              return 11.0;
            }
            if (co >= 120 && cv >= 100) {
              return 16.0;
            }
          }

          if (region === 'Murcia') {
            if (co <= 100 && cv < 100) {
              return 0;
            }
            if (co > 100 && co <= 120 && cv < 100) {
              return 4.75;
            }
            if (co > 120 && co <= 139 && cv < 100) {
              return 9.75;
            }
            if (co >= 120 && cv >= 100) {
              return 15.9;
            }
          }

          if (region === 'Comunidad Valenciana') {
            if (co <= 100 && cv < 100) {
              return 0;
            }
            if (co > 100 && co <= 120 && cv < 100) {
              return 4.75;
            }
            if (co > 120 && co <= 139 && cv < 100) {
              return 9.75;
            }
            if (co >= 120 && cv >= 100) {
              return 16.0;
            }
          }
        } else {
          Swal.fire(
            '',
            'Debes completar los siguientes campo: <br>' +
              ' Tipo de Vehículo <br>' +
              ' Provincia ',
            'warning'
          );
        }
      }
    } else {
      Swal.fire(
        '',
        'Debes completar los siguientes campo: <br>' +
          ' Tipo de Vehículo <br>' +
          ' Provincia ',
        'warning'
      );
    }
  }

  calcularImpuesto(impositivo, baseImponible): number {
    if (impositivo !== '' && baseImponible !== '') {
      return (baseImponible * impositivo) / 100;
    }
  }

  getDistintivo(dato: string): any {
    return this.http.post(Rutas + 'post_distintivo', { matricula: dato });
  }

  addFilesToSolicitud(datos): any {
    console.log(datos);
    return this.http.post(Rutas + 'add_files_solicitud', datos, {
      reportProgress: true,
      observe: 'events',
    });
  }

  addFilesToExpediente(datos): any {
    console.log(datos);
    return this.http.post(Rutas + 'add_files_expediente', datos, {
      reportProgress: true,
      observe: 'events',
    });
  }

  verifyFileToken(token): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const json = JSON.stringify({ token });
    return this.http.post(Rutas + 'public/verify_files_token', json, {
      headers,
    });
  }

  addFilesClienteToSolicitud(datos): any {
    console.log(datos);
    return this.http.post(Rutas + 'public/add_files_solicitud', datos, {
      reportProgress: true,
      observe: 'events',
    });
  }

  addFilesClienteToExpediente(datos): any {
    console.log(datos);
    return this.http.post(Rutas + 'public/add_files_expediente', datos, {
      reportProgress: true,
      observe: 'events',
    });
  }

  getSolicitudByGeneradoExpediente(genExp: number): Observable<any> {
    return this.http.get<any>(
      Rutas + 'solicitud/generado_expediente/' + genExp
    );
  }

  postViafirma(datos): Observable<any> {
    console.log('Datos llamada viafirma', datos);
    return this.http.post<any>(Rutas + 'post_viafirma', datos);
  }

  postViafirmaFromSolicitudes(datos): Observable<any> {
    return this.http.post<any>(Rutas + 'solicitud/post_viafirma', datos);
  }

  getEITV(bastidor: string): Observable<any> {
    return this.http.get<any>(Rutas + 'get_eitv?bastidor=' + bastidor);
  }

  /*
  private tVehiculo=[
    {id: "00", descripcion: "0-CAMION"},
    {id: "01", descripcion: "1-CAMION PLATAFORMA"},
    {id: "02", descripcion: "2-CAMION CAJA"},
    {id: "03", descripcion: "3-CAMION FURGON"},
    {id: "04", descripcion: "4-CAMION BOTELLERO"},
    {id: "05", descripcion: "5-CAMION CISTERNA"},
    {id: "06", descripcion: "6-CAMION JAULA"},
    {id: "07", descripcion: "7-CAMION FRIGORIFICO"},
    {id: "08", descripcion: "8-CAMION TALLER"},
    {id: "09", descripcion: "9-CAMION PARA CANTERA"},
    {id: "0A", descripcion: "0A-CAMION PORTAVEHICULOS"},
    {id: "0B", descripcion: "0B-CAMION MIXTO"},
    {id: "0C", descripcion: "0C-CAMION PORTACONTENEDORES"},
    {id: "0D", descripcion: "0D-CAMION BASURERO"},
    {id: "0E", descripcion: "0E-CAMION ISOTERMO"},
    {id: "0F", descripcion: "0F-CAMION SILO"},
    {id: "0G", descripcion: "0G-VEHICULO MIXTO ADAPTABLE"},
    {id: "10", descripcion: "10-CAMION ARTICULADO"},
    {id: "11", descripcion: "11-CAMION ARTICULADO PLATAFORMA"},
    {id: "12", descripcion: "12-CAMION ARTICULADO CAJA"},
    {id: "13", descripcion: "13-CAMION ARTICULADO FURGON"},
    {id: "14", descripcion: "14-CAMION ARTICULADO BOTELLERO"},
    {id: "15", descripcion: "15-CAMION ARTICULADO CISTERNA"},
    {id: "16", descripcion: "16-CAMION ARTICULADO JAULA"},
    {id: "17", descripcion: "17-CAMION ARTICULADO FRIGORIFICO"},
    {id: "18", descripcion: "18-CAMION ARTICULADO TALLER"},
    {id: "19", descripcion: "19-CAMION ARTICULADO PARA CANTERA"},
    {id: "1A", descripcion: "1A-CAMION ARTICULADO VIVIENDA O CARAVANA"},
    {id: "1C", descripcion: "1C-CAMION ARTICULADO HORMIGONERA"},
    {id: "1D", descripcion: "1D-CAMION ARTICULADO VOLQUETE"},
    {id: "1E", descripcion: "1E-CAMION ARTICULADO GRUA"},
    {id: "1F", descripcion: "1F-CAMION ARTICULADO CONTRA INCENDIOS"},
    {id: "20", descripcion: "20-FURGONETA"},
    {id: "21", descripcion: "21-FURGONETA MIXTA"},
    {id: "22", descripcion: "22-AMBULANCIA"},
    {id: "23", descripcion: "23-COCHE FUNEBRE"},
    {id: "24", descripcion: "24-CAMIONETA"},
    {id: "25", descripcion: "25-TODO TERRENO"},
    {id: "30", descripcion: "30-AUTOBUS"},
    {id: "31", descripcion: "31-AUTOBUS ARTICULADO"},
    {id: "32", descripcion: "32-AUTOBUS MIXTO"},
    {id: "40", descripcion: "40-TURISMO"},
    {id: "50", descripcion: "50-MOTOCICLETA DE 2 RUEDAS SIN SIDECAR"},
    {id: "51", descripcion: "51-MOTOCICLETA CON SIDECAR"},
    {id: "52", descripcion: "52-MOTOCARRO"},
    {id: "53", descripcion: "53-AUTOMOVIL DE 3 RUEDAS"},
    {id: "54", descripcion: "54-CUATRICICLO"},
    {id: "60", descripcion: "60-COCHE DE INVALIDO"},
    {id: "70", descripcion: "70-VEHICULO ESPECIAL"},
    {id: "80", descripcion: "80-TRACTOR AGRICOLA"},
    {id: "81", descripcion: "81-TRACTOR INDUSTRIAL"},
    {id: "82", descripcion: "82-MAQUINARIA AUTOPROPULSADA"},
    {id: "90", descripcion: "90-SEMIRREMOLQUE"},
    {id: "91", descripcion: "91-REMOLQUE"},
    {id: "92", descripcion: "92-REMOLQUE ESPECIAL"},
    {id: "93", descripcion: "93-SEMIRREMOLQUE FRIGORIFICO"},
    {id: "94", descripcion: "94-SEMIRREMOLQUE CISTERNA"},
    {id: "95", descripcion: "95-SEMIRREMOLQUE PORTAVEHICULOS"},
    {id: "96", descripcion: "96-SEMIRREMOLQUE VOLQUETE"},
    {id: "97", descripcion: "97-REMOLQUE CARAVANA"},
    {id: "98", descripcion: "98-SEMIRREMOLQUE GRUA"},
    {id: "99", descripcion: "99-SEMIRREMOLQUE TALLER"},
    {id: "9A", descripcion: "9A-REMOLQUE VIVIENDA O CARAVANA"},
    {id: "9B", descripcion: "9B-REMOLQUE PLATAFORMA"},
    {id: "9C", descripcion: "9C-REMOLQUE CARGA ESPECIAL"},
    {id: "9D", descripcion: "9D-REMOLQUE BASCULANTE"},
    {id: "9E", descripcion: "9E-REMOLQUE HORMIGONERA"},
    {id: "9F", descripcion: "9F-REMOLQUE CISTERNA"},
    {id: "9G", descripcion: "9G-REMOLQUE JAULA"},
    {id: "9H", descripcion: "9H-REMOLQUE PORTACONTENEDORES"},
    {id: "9J", descripcion: "9J-REMOLQUE TALLER"},
    {id: "9K", descripcion: "9K-REMOLQUE PARA CANTERA"},
    {id: "9L", descripcion: "9L-REMOLQUE GRUA"},
    {id: "9M", descripcion: "9M-REMOLQUE CONTRA INCENDIOS"}
  ];

  getTVehiculo(){
    return this.tVehiculo;
  }*/
}
